// extracted by mini-css-extract-plugin
export default {"featuredWrapper":"_3q_QlGXGokbo3QAQip6q38"};